class HovReveal extends HTMLElement {
  connectedCallback() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      this.dataset.visible = 'true';
      return;
    }
    this.observer = new IntersectionObserver(([entry]) => {
      if (!entry.isIntersecting) return;
      this.dataset.visible = 'true';
      this.observer.disconnect();
    }, { rootMargin: '0px 0px -8% 0px' });
    this.observer.observe(this);
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }
}

if (!customElements.get('hov-reveal')) customElements.define('hov-reveal', HovReveal);

class HovRecentlyViewed extends HTMLElement {
  async connectedCallback() {
    const current = this.dataset.currentHandle;
    const key = 'hovViewedHandles';
    let handles = [];
    try { handles = JSON.parse(localStorage.getItem(key) || '[]'); } catch (_) {}
    const previous = handles.filter((handle) => handle !== current).slice(0, 4);
    localStorage.setItem(key, JSON.stringify([current, ...previous].filter(Boolean).slice(0, 5)));
    if (!previous.length) return;

    const products = (await Promise.all(previous.map(async (handle) => {
      try {
        const response = await fetch(`${window.Shopify.routes.root}products/${encodeURIComponent(handle)}.js`);
        return response.ok ? response.json() : null;
      } catch (_) { return null; }
    }))).filter(Boolean);
    if (!products.length) return;

    const grid = this.querySelector('[data-recent-grid]');
    const currency = this.dataset.moneyFormat;
    products.forEach((product) => {
      const card = document.createElement('article');
      card.className = 'hov-product-card';
      const link = document.createElement('a');
      link.className = 'hov-product-card__media';
      link.href = product.url;
      const image = document.createElement('img');
      image.src = product.featured_image;
      image.alt = product.title;
      image.loading = 'lazy';
      image.width = 720;
      image.height = 900;
      link.append(image);
      const meta = document.createElement('div');
      meta.className = 'hov-product-card__meta';
      const title = document.createElement('h3');
      title.className = 'hov-product-card__title';
      const titleLink = document.createElement('a');
      titleLink.href = product.url;
      titleLink.textContent = product.title;
      title.append(titleLink);
      const price = document.createElement('div');
      price.className = 'hov-product-card__price';
      try {
        price.textContent = new Intl.NumberFormat(document.documentElement.lang, { style: 'currency', currency }).format(product.price / 100);
      } catch (_) { price.textContent = `${(product.price / 100).toFixed(2)} ${currency}`; }
      meta.append(title, price);
      card.append(link, meta);
      grid.append(card);
    });
    this.hidden = false;
  }
}

if (!customElements.get('hov-recently-viewed')) customElements.define('hov-recently-viewed', HovRecentlyViewed);
